// The caret work shared by every fixed digit mask on the site. A mask reformats
// the field on each keystroke, which moves the punctuation around, so the caret
// has to be put back or correcting a typo mid-number throws it to the end and
// the rest gets retyped backwards. That restore is identical whatever the
// punctuation is, so it lives here and each mask supplies only its own format
// function. lib/phone_mask.js is the one mask today; a second would add only its
// format.

const countDigits = (value) => (value.match(/\d/g) || []).length;

// The index just past the Nth digit of `value`. A caret remembered as a
// character offset would drift as the brackets, spaces and dashes move;
// remembered as a digit count it lands back where it was.
const caretAfterDigits = (value, count) => {
  if (count === 0) return 0;

  let seen = 0;
  for (let index = 0; index < value.length; index += 1) {
    if (/\d/.test(value[index])) {
      seen += 1;
      if (seen === count) return index + 1;
    }
  }
  return value.length;
};

// Reformat a focused input in place through `format`.
//
// Backspacing over a piece of punctuation deletes a character the mask puts
// straight back, so that keypress reads as moving the caret left past it and the
// next one deletes a digit. That is the ordinary behaviour of a fixed mask and it
// is why no beforeinput handling is needed here.
export const maskDigitInput = (input, format) => {
  const caretIndex = input.selectionStart ?? input.value.length;
  const digitsBeforeCaret = countDigits(input.value.slice(0, caretIndex));

  input.value = format(input.value);

  const caret = caretAfterDigits(input.value, digitsBeforeCaret);
  input.setSelectionRange(caret, caret);
};
